export default __webpack_public_path__ + "img/Heart.a7890362.png";